export const BRAND_NAME = 'Krishna365';
// Note: It is the main site url. Ex - krishna365.com, etc.
export const BRAND_DOMAIN = 'krishna365.com';
// Note: It is the main site url. Ex - krishna365.com, etc.
export const BRAND_DOMAIN_SKIN_URL = 'krishna365.com';
export const PROVIDER = 'BetFair';
export const PROVIDER_ID = 'BetFair';
export const BACKEND_DOMAIN = 'krna79.com';
